import { API_NOTIFICATIONS_URL } from 'library';

export const NOTIFICATIONS_KEY = 'notifications';

export const NOTIFICATIONS_URL = `${API_NOTIFICATIONS_URL}/notifications`;
